import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { Address, AddressInput } from '../../Components/AddressInput';
import { Field } from '../../Field';
import { FieldContainer } from '../../Components';

export type AddressFieldProps = {
    id?: string;
    name: string;
    label: string;
    description?: string;
    required?: boolean;
    disabled?: boolean;
    initialValue?: {
        street?: string;
        city?: string;
        postcode?: string;
        country?: string;
    };
};

export const AddressField: FunctionComponent<AddressFieldProps> = ({
    id,
    name,
    label,
    description,
    initialValue,
    required,
    disabled,
}) => {
    const isFulfilled = useCallback((value: Address) => {
        if (!value || typeof value !== 'object') {
            return false;
        }

        if (Object.keys(value).length === 0) {
            return false;
        }

        return true;
    }, []);

    return (
        <Field<Address>
            id={id}
            name={name}
            initialValue={initialValue}
            required={required}
            isFulfilled={isFulfilled}
        >
            {({
                fieldId,
                value,
                setValue,
                onBlur,
                errors,
                isValid,
                descriptionId,
                errorId,
                required,
                requiredStrategy,
            }) => {
                return (
                    <FieldContainer
                        errorId={errorId}
                        errors={errors}
                        descriptionId={descriptionId}
                        description={description}
                    >
                        <AddressInput
                            id={fieldId}
                            label={label}
                            name={name}
                            value={value}
                            onChange={setValue}
                            onBlur={onBlur}
                            aria-invalid={isValid === false}
                            aria-errormessage={errorId}
                            aria-describedby={descriptionId}
                            required={required}
                            requiredStrategy={requiredStrategy}
                            disabled={disabled}
                        />
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
